import React, { useState, useRef } from "react";

import "./index.scss";

const VerificationCodeInput = ({ length = 6, onComplete }) => {
   const [code, setCode] = useState(new Array(length).fill(""));
   const inputRefs = useRef([]);

   const handleChange = (index, value) => {
      if (!/^[0-9]?$/.test(value)) return;

      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      if (value && index < length - 1) {
         inputRefs.current[index + 1].focus();
      }

      if (newCode.every((digit) => digit !== "")) {
         onComplete?.(newCode.join(""));
      }
   };

   const handleKeyDown = (index, e) => {
      if (e.key === "Backspace" && !code[index] && index > 0) {
         inputRefs.current[index - 1].focus();
      }
   };

   const handlePaste = (e) => {
      e.preventDefault();
      const pasteData = e.clipboardData
         .getData("text")
         .trim()
         .slice(0, length);
      if (!/^\d+$/.test(pasteData)) return;

      const newCode = pasteData.split("").concat(new Array(length - pasteData.length).fill(""));
      setCode(newCode);
      onComplete?.(newCode.join(""));

      const nextIndex = Math.min(pasteData.length, length - 1);
      inputRefs.current[nextIndex]?.focus();
   };

   return (
      <div className="verification-code-input">
         {code.map((digit, index) => {
            return (
               <input
                  key={index}
                  ref={(el) => (inputRefs.current[index] = el)}
                  type="text"
                  value={digit}
                  maxLength={1}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  className={!!digit && "filled"}
               />
            );
         })}
      </div>
   );
};

export default VerificationCodeInput;
